// Package imports:
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
// Component imports:
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
// Service imports:
import { isUserLoggedIn } from '../../services/loginUtils';
// Type imports:
import { RootState } from '../../redux-store/reducers';

type ReduxProps = ConnectedProps<typeof connector>;
interface IOwnProps {
    showModal: boolean,
    closeModal(): void
}
type Props = ReduxProps & IOwnProps;

const AboutPrivateData: React.FC<Props> = ({ showModal, closeModal, hasEmsToken }) => {
    return (
        <Modal
            show={showModal}
            onHide={() => closeModal()}
        >
            <Modal.Header>
                {
                    (hasEmsToken)
                    ? (
                        <h4 className='modal-title green'>
                            <i className='fas fa-check' /> PRIVATE DATA
                        </h4>
                    ) : (
                        <h4 className='modal-title red'>
                            <i className='fas fa-ban' /> NO PRIVATE DATA
                        </h4>
                    )
                }
            </Modal.Header>
            <Modal.Body>
                <p>Having access to private market data means that you will see your orders and trades.</p>
                <p>Without private market data you can still see alerts, alert configurations and comments for your group.</p>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant='dark'
                    onClick={() => closeModal()}
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

function mapStateToProps({ loginReducer }: RootState) {
    const { isLoggedIn, hasEmsToken } = isUserLoggedIn(loginReducer);
    return {
        isLoggedIn,
        hasEmsToken
    }
}

const connector = connect(mapStateToProps);
export default connector(AboutPrivateData);